import * as React from 'react';
import { useCallback, useRef, useState } from 'react';
import { createStyles, Fade, Grid, Popper, withStyles } from '@material-ui/core';
import Button, { ButtonVariants } from './Button';
import { Text } from '../Text';
import { toCssValue } from '@topconagriculture/theme';
import { useOnClickOutside } from '@topconagriculture/frontend-utils';
const styles = (theme) => createStyles({
    warningPopperContainer: {
        zIndex: 9999,
    },
    warningPopper: {
        borderRadius: theme.common.borderRadius.default,
        backgroundColor: 'white',
        padding: toCssValue([3, 10, 10]),
        boxShadow: `0 1px 5px ${theme.color.grey.light}`,
        textAlign: 'center',
    },
    yesNoButton: {
        minHeight: 'auto',
    },
});
const PopConfirmButton = (props) => {
    const { placement = 'top', timeout = 350, bypassConfirm = false, confirmLabel, cancelLabel, message, buttonProps = {}, onConfirm, onCancel, confirmButtonVariant = ButtonVariants.primary, cancelButtonVariant = ButtonVariants.secondary, classes, children, hideOnClickOutside, testId = 'PopConfirmButton', } = props;
    const ref = useRef(null);
    const [warningAnchorEl, setWarningAnchorEl] = useState(null);
    const warningPopoverIsOpen = Boolean(warningAnchorEl);
    const warningPopoverId = warningPopoverIsOpen ? 'popconfirm-button-popper' : undefined;
    const toggleWarningPopper = useCallback((event) => {
        setWarningAnchorEl(warningAnchorEl ? null : event.currentTarget);
    }, [warningAnchorEl]);
    const hideWarningPopper = useCallback(() => {
        setWarningAnchorEl(null);
    }, []);
    const onClickHandler = useCallback((event) => {
        if (bypassConfirm) {
            return onConfirm();
        }
        toggleWarningPopper(event);
    }, [bypassConfirm, onConfirm]);
    const onCancelHandler = useCallback((event) => {
        toggleWarningPopper(event);
        if (onCancel) {
            onCancel();
        }
    }, [onCancel, toggleWarningPopper]);
    const onConfirmHandler = useCallback((event) => {
        toggleWarningPopper(event);
        if (onConfirm) {
            onConfirm();
        }
    }, [onConfirm, toggleWarningPopper]);
    useOnClickOutside(hideOnClickOutside && ref, hideWarningPopper);
    return (React.createElement(React.Fragment, null,
        React.createElement(Popper, { ref: ref, "data-testid": `${testId}`, id: warningPopoverId, open: warningPopoverIsOpen, className: classes.warningPopperContainer, anchorEl: warningAnchorEl, transition: true, placement: placement }, ({ TransitionProps }) => (React.createElement(Fade, Object.assign({}, TransitionProps, { timeout: timeout }),
            React.createElement("div", { className: classes.warningPopper },
                React.createElement(Text, { block: true, lineHeight: 3 }, message),
                React.createElement(Grid, { container: true, spacing: 2 },
                    React.createElement(Grid, { item: true },
                        React.createElement(Button, { "data-testid": `${testId}-cancel`, variant: cancelButtonVariant, className: classes.yesNoButton, size: 'small', label: cancelLabel, onClick: onCancelHandler })),
                    React.createElement(Grid, { item: true },
                        React.createElement(Button, { className: classes.yesNoButton, "data-testid": `${testId}-confirm`, size: 'small', variant: confirmButtonVariant, label: confirmLabel, onClick: onConfirmHandler }))))))),
        children &&
            children({
                onClickHandler,
                isOpen: warningPopoverIsOpen,
                requestClose: hideWarningPopper,
            }),
        !children && React.createElement(Button, Object.assign({}, buttonProps, { onClick: onClickHandler, "data-testid": `${testId}-button` }))));
};
export default withStyles(styles)(PopConfirmButton);
//# sourceMappingURL=PopConfirmButton.js.map